var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_281",
    "data-name": "Rectangle 281",
    width: 14,
    height: 14,
    fill: "white"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Search",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_432",
    "data-name": "Group 432",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_458",
    "data-name": "Path 458",
    d: "M6.02,0H6.1c.126.027.253.066.38.081A4.985,4.985,0,0,1,8.008.534a5.678,5.678,0,0,1,2.816,2.925,5.014,5.014,0,0,1,.407,1.677,8.04,8.04,0,0,1-.058,1.446,5.561,5.561,0,0,1-.293,1.07,4.853,4.853,0,0,1-.711,1.3c-.086.115-.078.169.018.264q1.709,1.7,3.413,3.408a1.324,1.324,0,0,1,.4.552v.3c-.017.014-.042.024-.05.041a.692.692,0,0,1-1.2.232L9.191,10.184c-.035-.035-.071-.069-.108-.1-.035.022-.066.039-.1.059-.246.156-.485.323-.737.465a5.375,5.375,0,0,1-2.206.651,4.987,4.987,0,0,1-1.6-.109,5.987,5.987,0,0,1-1.637-.638A5.667,5.667,0,0,1,1.256,9.183,5.264,5.264,0,0,1,.238,7.233,6.183,6.183,0,0,1,.015,6.062,5.633,5.633,0,0,1,.224,4.054,5.744,5.744,0,0,1,1.03,2.384a5.524,5.524,0,0,1,1.1-1.163A5.383,5.383,0,0,1,3.552.4a5.063,5.063,0,0,1,1.2-.321C4.883.064,5.014.027,5.145,0h.164l.106.025H5.86L6.02,0M5.606,1.422A4.2,4.2,0,0,0,1.4,5.34a4.144,4.144,0,0,0,1.475,3.5,4.007,4.007,0,0,0,2.5,1.018A4.129,4.129,0,0,0,8.588,8.648,4.119,4.119,0,0,0,9.844,5.3,4.187,4.187,0,0,0,5.606,1.422",
    transform: "translate(0 0)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_459",
    "data-name": "Path 459",
    d: "M5.8.024H5.356a.053.053,0,0,0,0-.025H5.8a.1.1,0,0,0,0,.024",
    transform: "translate(0.059 0)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_460",
    "data-name": "Path 460",
    d: "M5.8.024a.1.1,0,0,1,0-.024h.164L5.8.024",
    transform: "translate(0.064 0)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_461",
    "data-name": "Path 461",
    d: "M5.36,0a.1.1,0,0,1,0,.024L5.251,0Z",
    transform: "translate(0.058 0)",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchWhite);
export default __webpack_public_path__ + "static/media/Search-white.74d13b321b6a65a239d0dac1e726996d.svg";
export { ForwardRef as ReactComponent };